import React, { useEffect } from "react";
import { useBluelagoon } from "@bluelagoon";

export default function IntegrationAlertBadge() {
    const { call, response } = useBluelagoon({
        method: "getIntegrationAlertCount",
        setIsLoading: false,
    });

    useEffect(() => {
        call();
        const interval = setInterval(() => call(), 60000);
        return () => clearInterval(interval);
    }, []);

    const count = response?.data?.count || 0;
    if (count === 0) return null;

    return (
        <span className="absolute -top-1 -right-1 bg-amber-400 text-amber-900 text-[10px] font-bold min-w-[18px] h-[18px] flex items-center justify-center rounded-full px-1">
            {count > 99 ? "99+" : count}
        </span>
    );
}
